import { render, staticRenderFns } from "./GenericLoading.vue?vue&type=template&id=77872e68&"
import script from "./GenericLoading.vue?vue&type=script&lang=js&"
export * from "./GenericLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports